"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typesAlias = exports.rpc = exports.types = void 0;
const auction_1 = __importDefault(require("./auction"));
const nft_1 = __importDefault(require("./nft"));
const primitives_1 = __importDefault(require("./primitives"));
const tokens_1 = __importDefault(require("./tokens"));
const metaverse_1 = __importDefault(require("./metaverse"));
const vesting_1 = __importDefault(require("./vesting"));
const collatorStaking_1 = __importDefault(require("./collatorStaking"));
const tokenization_1 = __importDefault(require("./tokenization"));
const estate_1 = __importDefault(require("./estate"));
const utils_1 = require("./utils");
const defs = {
    primitives: primitives_1.default,
    nft: nft_1.default,
    estate: estate_1.default,
    auction: auction_1.default,
    metaverse: metaverse_1.default,
    tokens: tokens_1.default,
    vesting: vesting_1.default,
    collatorStaking: collatorStaking_1.default,
    tokenization: tokenization_1.default
};
exports.types = (0, utils_1.typesFromDefs)(defs);
exports.rpc = (0, utils_1.jsonrpcFromDefs)(defs);
exports.typesAlias = (0, utils_1.typesAliasFromDefs)(defs);
